import { apiInstance } from "v2/infrastructure/common/api/apiClient";
import restoreBenefits from "v2/infrastructure/Benefits/builders/restoreBenefits";
import { BenefitType } from "v2/infrastructure/Benefits/types/BenefitTypes";
import { BenefitStates } from "v2/infrastructure/Benefits/types/BenefitStates";
import Benefit from "v2/domain/benefits/entities/Benefit";
import CustomBenefit from "v2/domain/benefits/entities/CustomBenefit";

type GetBenefitModelInterface = {
  content: BenefitModelInterface[];
};

export type BenefitModelInterface =
  | BenefitItemCoreModelInterface
  | BenefitItemPlugAndPlayModelInterface
  | BenefitItemCustomModelInterface;

export type BenefitItemCoreModelInterface = {
  type: BenefitType.CORE;
  benefit: string;
  name: string;
  state: BenefitStates;
  tags: string[];
};

type BenefitItemPlugAndPlayModelInterface = {
  type: BenefitType.PLUG_AND_PLAY;
  benefit: string;
  name: string;
  slug: string;
  iconUrl: string;
  state: BenefitStates;
  tags: string[];
};

export type BenefitItemCustomModelInterface = {
  type: BenefitType.CUSTOM;
  benefit: string;
  state: BenefitStates;
  tags: string[];
  name: string;
  iconUrl: string;
};

const getBenefits = async ({
  companyId,
  benefitModelId,
}: {
  companyId: string;
  benefitModelId: string;
}): Promise<(Benefit | CustomBenefit)[]> => {
  const { data } = await apiInstance.get<GetBenefitModelInterface>(
    `/v2/companies/${companyId}/benefit-models/${benefitModelId}/benefits`,
    {}
  );
  return data.content.map((benefit) => restoreBenefits(benefit));
};

export default getBenefits;
